module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-tab teams"
  }, [_c('wb-datatable', _vm._b({
    attrs: {
      "disallowDeleting": true,
      "disallowEditing": true,
      "allowCreation": false,
      "searchKey": 'name',
      "customControls": [{
          icon: 'add',
          name: 'Add parent team',
          handler: function (row) {
            _vm.openDialog(row);
          }
        },
        {
          icon: 'delete',
          name: 'Remove parent team',
          handler: function (row) {
            _vm.openConfirmDialog(row);
          }
        } ]
    }
  }, 'wb-datatable', _vm.tableProps, false)), _vm._v(" "), _c('md-dialog', {
    ref: "dialog"
  }, [_c('md-dialog-title', [_vm._v("Edit team assignment")]), _vm._v(" "), _c('md-dialog-content', [(_vm.organization) ? _c('form', [_c('div', {
    staticClass: "teams-list"
  }, [_c('p', [_vm._v("Team name")]), _vm._v("\n          " + _vm._s(_vm.organization.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "teams-list"
  }, [_c('p', [_vm._v("Team id")]), _vm._v("\n          " + _vm._s(_vm.organization.id) + "\n        ")]), _vm._v(" "), (_vm.organization && _vm.organization.parentTeams && _vm.organization.parentTeams.length > 0) ? _c('div', {
    staticClass: "teams-list"
  }, [_c('p', [_vm._v("Parent teams")]), _vm._v("\n          " + _vm._s(_vm.organization.parentTeamsNames) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.organization && _vm.organization.childTeams && _vm.organization.childTeams.length > 0) ? _c('div', {
    staticClass: "teams-list"
  }, [_c('p', [_vm._v("Child teams")]), _vm._v("\n          " + _vm._s(_vm.organization.childTeamsNames) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('multiselect', {
    attrs: {
      "options": _vm.newParentTeam,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "label": 'name',
      "placeholder": "Assign to another parent team",
      "selectLabel": ""
    },
    model: {
      value: (_vm.newTeam),
      callback: function($$v) {
        _vm.newTeam = $$v
      },
      expression: "newTeam"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeDialog(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeDialog(true)
      }
    }
  }, [_vm._v("Add")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "confirmDialog"
  }, [_c('md-dialog-title', [_vm._v("Are you sure you want to remove this team from the selected parent team?")]), _vm._v(" "), _c('md-dialog-content', [(_vm.organization) ? _c('form', [_c('div', {
    staticClass: "teams-list"
  }, [_c('p', [_vm._v("Team name")]), _vm._v("\n          " + _vm._s(_vm.organization.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "teams-list"
  }, [_c('p', [_vm._v("Team id")]), _vm._v("\n          " + _vm._s(_vm.organization.id) + "\n        ")]), _vm._v(" "), _c('md-input-container', [_c('multiselect', {
    attrs: {
      "options": _vm.parentTeamsList,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "label": 'name',
      "placeholder": "Remove from parent team",
      "selectLabel": ""
    },
    model: {
      value: (_vm.oldParentTeam),
      callback: function($$v) {
        _vm.oldParentTeam = $$v
      },
      expression: "oldParentTeam"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeConfirmDialog(false)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        return _vm.closeConfirmDialog(true)
      }
    }
  }, [_vm._v("Delete")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6748e6a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminTabs/AdminTeams.vue
// module id = 314
// module chunks = 2